import initTextOverMedia from "../initTextOverMedia.js";

document.addEventListener("DOMContentLoaded", () => {
  initTextOverMedia();
});
